import { PageType } from "@product/scmp-sdk";

export const pathname = "/posties/events";

export const page = {
  route(query: QueryParameters) {
    return { pathname, query: { ...query, pageType: PageType.PostiesEvents } };
  },
};
